import React, { useRef, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon, GiftIcon, CheckIcon } from "lucide-react";
import { BONUSES } from "../lib/data";
import { scrollToBuy } from "./BuyButton";
export function BonusSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const goTo = (index: number) => {
    const next = (index + BONUSES.length) % BONUSES.length;
    const scroller = scrollerRef.current;
    const card = scroller?.children[next] as HTMLElement | undefined;
    if (card) scroller?.scrollTo({
      left: card.offsetLeft,
      behavior: "smooth"
    });
    setActiveIndex(next);
  };
  const handleScroll = () => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const cards = Array.from(scroller.children) as HTMLElement[];
    const center = scroller.scrollLeft + scroller.clientWidth / 2;
    const closest = cards.reduce((current, card, index) => Math.abs(card.offsetLeft + card.clientWidth / 2 - center) < current.distance ? {
      index,
      distance: Math.abs(card.offsetLeft + card.clientWidth / 2 - center)
    } : current, {
      index: 0,
      distance: Infinity
    });
    setActiveIndex(closest.index);
  };
  return <section className="px-4 py-6" data-id="element-23" data-mp="2jio6jhiwrm1h">
      <div className="rounded-2xl border border-[#8bc34a]/40 bg-[#0f2c4a]/85 p-5 backdrop-blur-sm" data-id="element-24" data-mp="2ogpr66vzftf2">
        <p className="text-center text-base font-semibold leading-relaxed text-slate-100" data-id="element-25" data-mp="1qth2y44lk69d">
          Pará, ya sabemos que con solo eso, no te organizás del todo. Por eso
          agregamos <span className="text-[#8bc34a]" data-id="element-26" data-mp="20remwfffbgw6">sin cargo</span> los
          siguientes bonos:
        </p>

        <div className="mt-3 flex items-center justify-center gap-2 rounded-full bg-[#8bc34a] px-4 py-1.5" data-id="element-27" data-mp="25qhv28qpa38d">
          <GiftIcon className="h-4 w-4 text-[#0f2c4a]" data-id="element-28" data-mp="3c6ttmaxfpn4h" />
          <span className="text-sm font-black uppercase text-[#0f2c4a]" data-id="element-29" data-mp="3c6acuxjit4s1">
            Gratis solo por hoy
          </span>
        </div>

        <div className="relative mt-5" data-id="element-30" data-mp="1h3f3lsk7df78">
          <div ref={scrollerRef} onScroll={handleScroll} className="flex snap-x snap-mandatory gap-3 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Carrusel de bonos incluidos" data-id="element-31" data-mp="1h23xvn775xdh">
            {BONUSES.map((bonus, index) => <article key={bonus.title} className="w-full flex-shrink-0 snap-center overflow-hidden rounded-xl bg-white shadow-lg" data-id="element-32" data-mp="ycxb9p3a8lme" data-mpi={index}>
                <button type="button" onClick={scrollToBuy} aria-label={`Ver oferta de ${bonus.title}`} className="block w-full overflow-hidden bg-slate-950" data-id="element-33" data-mp="tbq4ntcvlshb">
                  <img src={bonus.image} alt={`Preview del ${bonus.title}`} className="aspect-square w-full object-cover" data-id="element-34" data-mp="eo4zltwfxj6r" />
                </button>
                <div className="p-4" data-id="element-35" data-mp="htn49bz6cvi">
                  <p className="text-[11px] font-black uppercase tracking-wider text-[#6d9f30]" data-id="element-36" data-mp="5a4l36n5nolf">
                    Bono {index + 1} incluido
                  </p>
                  <h3 className="mt-1 text-lg font-black leading-tight text-[#0f2c4a]" data-id="element-37" data-mp="3ms5vi5omj9gm">
                    <span className="mr-1.5" data-id="element-38" data-mp="3rqh5cgex5jyu">{bonus.emoji}</span>
                    {bonus.title.replace(/^\d+\s-\s/, "")}
                  </h3>
                  <div className="mt-3 flex items-start gap-2" data-id="element-39" data-mp="o8yzgeipin12">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#8bc34a]" data-id="element-40" data-mp="o87hi6i18nt9" />
                    <p className="text-sm leading-snug text-slate-700" data-id="element-41" data-mp="9b6ntxga6is5">{bonus.desc}</p>
                  </div>
                  <p className="mt-3 text-xs font-bold text-[#6d9f30]" data-id="element-42" data-mp="e8yeyp93q0va">Incluido gratis hoy</p>
                </div>
              </article>)}
          </div>

          <button type="button" onClick={() => goTo(activeIndex - 1)} aria-label="Ver bono anterior" className="absolute -left-2 top-[31%] flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#0f2c4a] shadow-lg" data-id="element-43" data-mp="2z238w53havpe">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-44" data-mp="35hk6ns87zt8r" />
          </button>
          <button type="button" onClick={() => goTo(activeIndex + 1)} aria-label="Ver siguiente bono" className="absolute -right-2 top-[31%] flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#0f2c4a] shadow-lg" data-id="element-45" data-mp="30jaapfeo8om3">
            <ChevronRightIcon className="h-5 w-5" data-id="element-46" data-mp="3t63ey7r9s60u" />
          </button>
        </div>

        <div className="mt-3 flex justify-center gap-1.5" data-id="element-47" data-mp="3o70b2qn105ug">
          {BONUSES.map((bonus, index) => <button key={bonus.title} type="button" onClick={() => goTo(index)} aria-label={`Ver bono ${index + 1}`} className={`h-2 rounded-full transition-all ${activeIndex === index ? "w-6 bg-[#8bc34a]" : "w-2 bg-white/40"}`} data-id="element-48" data-mp="3jbumfk28od2o" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}